/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */

const campaigns = r => require.ensure([], () => r(require('./components/index')), 'campaigns');
const preview = r => require.ensure([], () => r(require('./components/preview')), 'campaigns');
const bulkpreview = r => require.ensure([], () => r(require('./components/bulkpreview')), 'campaigns');
const manageCampaign = {
    index:       r => require.ensure([], () => r(require('./components/manage/index')),         'manage-campaign'),
    create:      r => require.ensure([], () => r(require('./components/manage/create')),           'manage-campaign'),
    description: r => require.ensure([], () => r(require('./components/manage/edit/description')), 'manage-campaign'),
    email:       r => require.ensure([], () => r(require('./components/manage/edit/email')),       'manage-campaign'),
    sms:       r => require.ensure([], () => r(require('./components/manage/edit/sms')),       'manage-campaign'),
    landing:     r => require.ensure([], () => r(require('./components/manage/edit/landing')),     'manage-campaign'),
    education:    r => require.ensure([], () => r(require('./components/manage/edit/education')),    'manage-campaign'),
    schedule:    r => require.ensure([], () => r(require('./components/manage/edit/schedule')),    'manage-campaign'),
    review:    r => require.ensure([], () => r(require('./components/manage/edit/review')),    'manage-campaign')
};

export default [
    {
        name: 'campaigns',
        path: '/campaigns',
        alias: '/announcements',
        component: campaigns,
    },
    {
        name: 'preview',
        path: '/campaigns/preview/:id',
        alias: '/announcements/preview/:id',
        component: preview,
    },
    {
        name: 'bulk/preview',
        path: '/campaigns/bulk/preview/:id',
        component: bulkpreview,
    },
    {
        name: 'campaigns.index',
        path: '/campains/create',
        alias: '/announcements/create',
        component: manageCampaign.index,
        redirect: { name: 'campaigns.create' },
        children: [
            {
                name: 'campaigns.create',
                path: '/campaigns/create',
                alias: '/announcements/create',
                component: manageCampaign.create,
            },
            {
                name: 'campaigns.edit.description',
                path: '/campaigns/description/:id',
                alias: '/announcements/description/:id',
                component: manageCampaign.description,
            },
            {
                name: 'campaigns.edit.email',
                path: '/campaigns/email/:id',
                alias: '/announcements/email/:id',
                component: manageCampaign.email,
            },
            {
                name: 'campaigns.edit.sms',
                path: '/campaigns/sms/:id',
                alias: '/announcements/sms/:id',
                component: manageCampaign.sms,
            },
            {
                name: 'campaigns.edit.landing',
                path: '/campaigns/landing/:id',
                alias: '/announcements/landing/:id',
                component: manageCampaign.landing,
            },
            {
                name: 'campaigns.edit.education',
                path: '/campaigns/education/:id',
                alias: '/announcements/education/:id',
                component: manageCampaign.education,
            },
            {
                name: 'campaigns.edit.schedule',
                path: '/campaigns/schedule/:id',
                alias: '/announcements/schedule/:id',
                component: manageCampaign.schedule,
            },
            {
                name: 'campaigns.edit.review',
                path: '/campaigns/review/:id',
                alias: '/announcements/review/:id',
                component: manageCampaign.review,
            }
        ]
    }
]







// WEBPACK FOOTER //
// ./src/app/campaign/routes.js